import { render, staticRenderFns } from "./PlatformTable.vue?vue&type=template&id=140ed056"
import script from "./PlatformTable.vue?vue&type=script&lang=js"
export * from "./PlatformTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports